export default __webpack_public_path__ + "static/media/card-back.6ac6f05d.webp";